<template>
  <!-- 類別 -->
  <v-sheet class="categories__swiper" :class="isMobile ? 'mobile pt-7 pb-4' : 'py-3'" elevation="0" rounded>
    <!-- max-height: 200 is from (92 + 8) * 2. 92 is the height of one category, 8 is margin bottom of category, and the 2 is two rows -->
    <!-- 92 is from 44 + 4 + 44. 44 is the height of category image, 4 is margin bottom of category image. and the 44 is the height of category name -->
    <v-sheet
      class="categories__wrapper d-flex flex-wrap"
      :class="shouldCategoriesWrapperFlexColumn ? 'flex-column' : 'flex-row'"
      width="max-content"
      max-width="1280"
      :max-height="isMobile ? 200 : 300"
    >
      <!-- 80 is set for the width of category name -->
      <!-- mobile version works fine, and desktop and tablet versions still work, but they angers developer -->
      <v-sheet
        v-for="(category, idx) in categoryListOrNumber"
        :key="idx"
        class="categories__box"
        :class="categoriesBoxClassName"
        :width="80"
        :height="isMobile ? 92 : 90"
      >
        <div v-if="category.id">
          <nuxt-link :to="getCategoryURL(category.id)">
            <v-img class="category__icon mx-auto mb-1" :class="{ mobile: isMobile }" :src="getImage(category.icon_image)">
              <template #placeholder>
                <v-skeleton-loader boilerplate type="image" />
              </template>
            </v-img>

            <p class="category__name wd-text-center wd-text-black50 wd-mb-0">{{ category.name }}</p>
          </nuxt-link>
        </div>
        <v-skeleton-loader v-else boilerplate type="image" min-width="80" height="90" max-height="90" />
      </v-sheet>
    </v-sheet>
  </v-sheet>
</template>

<script>
export default defineComponent({
  name: 'CategoriesSwiper',
  props: {
    title: { type: String, default: '' },
    isMobile: { type: Boolean, default: false },
    regionId: { type: [String, Number], default: '' },
    items: { type: Array, default: () => [] },
  },
  setup() {
    const localePath = useLocalePath()
    return { localePath }
  },
  computed: {
    shouldCategoriesWrapperFlexColumn() {
      const categoryListLength = Array.isArray(this.categoryListOrNumber) ? this.categoryListOrNumber.length : this.categoryListOrNumber
      return this.isMobile && categoryListLength > 4
    },
    categoriesBoxClassName() {
      return this.isMobile ? 'mr-3 mb-2' : 'mx-4 my-4'
    },
    categoryListOrNumber() {
      return this.items.length > 0 ? this.items : 5
    },
  },
  methods: {
    getImage(path) {
      return `${this.$config.public.CDN_URI}${path}`
    },
    getCategoryURL(categoryID) {
      return this.regionId && categoryID ? this.localePath({ name: 'regions-rid-categories-id', params: { rid: this.regionId, id: categoryID } }) : ''
    },
  },
})
</script>

<style scoped lang="scss">
.categories__swiper {
  margin: 0 -16px;
  overflow-x: auto;

  &.mobile {
    margin: 0px;
  }

  .categories__box {
    cursor: pointer;

    .category__icon {
      width: 64px;
      height: 64px;
      &.mobile {
        width: 44px;
        height: 44px;
      }
    }
    .category__name {
      line-height: 22px;
      word-break: break-all;

      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
